import { Component, OnInit, HostBinding, ViewChild, Input, AfterViewInit, Optional, LOCALE_ID, Inject } from '@angular/core';
import { UserPerformerComponent } from '../user-performer/user-performer.component';
import { PositionPerformerComponent } from '../position-performer/position-performer.component';
import { ComponentPerformerComponent } from '../component-performer/component-performer.component';
import { BizComponentEntity } from '../../../../domain/entities/biz-component.entity';
import { ReportingLineComponent } from '../reporting-line/reporting-line.component';
import { MatrixPerformerComponent } from '../matrix-performer/matrix-performer.component';
import { HttpService } from '@ecp-caf/caf-common';
import { ActivityExecutorPerformerComponent } from '../activity-executor-performer/activity-executor-performer.component';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { OrganizationParticipantExpression, ActionScope, OrganizationLevel } from '../../../../domain/entities/organization-participant-expression';
import { VariablePerformerComponent } from '../variable-performer/variable-performer.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';


@Component({
  selector: 'app-performer-edit',
  templateUrl: './performer-edit.component.html',
  styleUrls: ['./performer-edit.component.scss'],
  providers: [
    WfLocalePipe,
 ]
})
export class PerformerEditComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  component: BizComponentEntity;
  performer: { type: string, value: any };
  performerType: string;
  userType: string;
  editState: string;
  tab = 'user';
  @Input() display = true;

  organizationLevelCollection = [
    {
      value: 'UNIT',
      text: this.localePipe.transform('component.participant.currentUnit'),
      orgId: 'currentUnit'
    }, {
      value: 'DEPARTMENT',
      text: this.localePipe.transform('component.participant.currentDepartment'),
      orgId: 'currentDepartment'
    }, {
      value: 'VARORGANIZATION',
      text: this.localePipe.transform('component.participant.variableOrganization'),
      orgId: ''
    }
    // , {
    //   value: 'ASSIGNORGANIZATION',
    //   text: this.localePipe.transform('component.participant.assignOrganization'),
    //   orgId: ''
    // }
  ];

  organizationParticipant: OrganizationParticipantExpression;

  @ViewChild(UserPerformerComponent) usersCmp: UserPerformerComponent;
  @ViewChild(VariablePerformerComponent) varCmp: VariablePerformerComponent;
  @ViewChild(PositionPerformerComponent) posiCmp: PositionPerformerComponent;
  @ViewChild(ComponentPerformerComponent) cmpCmp: ComponentPerformerComponent;
  @ViewChild(ReportingLineComponent) reportingLineCmp: ReportingLineComponent;
  @ViewChild(MatrixPerformerComponent) matrixCmp: MatrixPerformerComponent;
  @ViewChild(ActivityExecutorPerformerComponent) activityExecutorCmp: ActivityExecutorPerformerComponent;

  // @ViewChild("farrisOrgHelp") farrisOrgHelp: OrganizationSelectorComponent;

  constructor(
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private http: HttpService,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.organizationParticipant = new OrganizationParticipantExpression();
    this.organizationParticipant.actionScope = ActionScope.AssignUser;
    this.organizationParticipant.organizationLevel = OrganizationLevel.DEPARTMENT;
    this.organizationParticipant.organizationId = 'currentDepartment';
    this.organizationParticipant.organizationName = this.localePipe.transform('component.participant.currentDepartment');
    this.organizationParticipant.includeChildren = false;
    this.organizationParticipant.tag = 'variable';
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.performer) {
      switch (this.performer.type) {
        case 'wf.UserParticipantExpression':
          this.usersCmp.users = [];
          this.usersCmp.users.push(this.performer.value);
          // 2023-5-23 用户参与者支持编辑时单选+显示已选用户；
          this.usersCmp.multiSelect = this.editState === 'edit' ? false : true;
          // 考虑到兼容历史数据，暂时不使用用户参与者实体类中的userType属性
          if (this.performer.value.performerId && this.performer.value.performerId.charAt(0) === '{') {
            const url = '/api/runtime/wf/v1.0/reportingOrgType/hasAdminOrg';
            this.http.get(url).subscribe((data: any) => {
              this.usersCmp.userTypeButtonNeedShow = data;
              this.usersCmp.userType = 'variable';
              this.usersCmp.curOrgType = this.performer.value.orgType === 'Sys' ? 'Sys' : 'Administrative_organization';
              this.usersCmp.condition = this.performer.value.condition;
              // 根据表达式中的函数名判断是否使用的是上下文变量
              const isContextVariable = this.performer.value.performerId.indexOf('GetContextParameter') >= 0;
              this.usersCmp.variableOrgTypes = isContextVariable ? [
                { name: '系统用户', value: 'Sys' }
              ] : [
                { name: '系统用户', value: 'Sys' },
                { name: '员工', value: 'Administrative_organization' }
              ];
            });
          } else {
            this.usersCmp.userType = 'user';
            this.usersCmp.condition = this.performer.value.condition;
          }
          break;
        case 'wf.VariableParticipantExpression':
          // TODO:参与者只保留一份最好
          this.varCmp.users = [];
          this.varCmp.users.push(this.performer.value);
          this.varCmp.user = this.performer.value;
          this.varCmp.editState = this.editState === 'edit' ? false : true;
          // 判断是变量参与者
          if (this.performer.value.varValue && this.performer.value.varValue.charAt(0) === '{') {
            // 根据表达式中的函数名判断是否使用的是上下文变量
            const isContextVariable = this.performer.value.varValue.indexOf('GetContextParameter') >= 0;
            // 上下文变量的变量值类型只有系统用户id
            this.varCmp.variableOrgTypes = isContextVariable ? [
              { name: '用户ID', value: 'Sys' }
            ] : [
              { name: '用户ID', value: 'Sys' },
              { name: '员工ID', value: 'Administrative_staff' },
            ];
            // 如果是insuite场景还要增加行政组织id
            this.varCmp.curOrgType = this.performer.value.varType;
            this.varCmp.relationShipType = this.performer.value.relation;
            this.varCmp.condition = this.performer.value.condition;
          }
          break;
        case 'wf.PositionParticipantExpression':
          this.posiCmp.editState = this.editState === 'edit' ? false : true;
          this.posiCmp.position = Object.assign({}, this.performer.value);
          this.posiCmp.performerName = this.posiCmp.position.performerName;
          if (this.posiCmp.position.positionType === '0') {
            this.posiCmp.newFilter = { positionType: '0' };
          } else {
            this.posiCmp.newFilter = { positionType: '1' };
          }
          break;
        case 'wf.ReportingLineParticipantExpression':
          // this.tab = 'report';
          this.reportingLineCmp.setReportingLineDataEntity = this.performer.value;
          break;
        case 'wf.ComponentParticipantExpression':
          // this.tab = 'component';
          this.cmpCmp.component = this.performer.value;
          break;
        case 'wf.MatrixParticipantExpression':
          // this.tab = 'matrix';
          this.matrixCmp.setMatrixDataEntity = this.performer.value;
          break;
        case 'wf.ActivityExecutorParticipantExpression':
          // this.tab = 'activityExecutor';
          this.activityExecutorCmp.activityExecutors = [];
          this.activityExecutorCmp.activityExecutors.push(this.performer.value);
          this.activityExecutorCmp.condition = this.performer.value.condition;
          break;
        case 'wf.OrganizationParticipantExpression':
          if (this.performer.value.organizationLevel === OrganizationLevel.DEFAULT) {
            if(this.performer.value.tag === 'expression') {
              this.performer.value.organizationLevel = OrganizationLevel.VARORGANIZATION;
            }
            // else if(this.performer.value.tag === 'assign') {
            //   this.performer.value.organizationLevel = OrganizationLevel.ASSIGNORGANIZATION;
            // }
          } 
          this.organizationParticipant = this.performer.value;
          if (this.performer.value.OrganizationLevel === OrganizationLevel.DEPARTMENT && this.performer.value.tag === 'expression') {
            this.performer.value.OrganizationLevel === OrganizationLevel.VARORGANIZATION;
          }
          break;
      }
    }
    if (this.performerType) {
      switch (this.performerType) {
        case 'wf.UserParticipantExpression':
          this.usersCmp.userType = 'user';
          break;
      }
    }
  }

  valueChange(event: any) {
    switch (event.value) {
      case this.organizationLevelCollection[0].value:
        this.organizationParticipant.organizationId = this.organizationLevelCollection[0].orgId;
        this.organizationParticipant.organizationName = this.organizationLevelCollection[0].text;
        this.organizationParticipant.includeChildren = true;
        break;
      case this.organizationLevelCollection[1].value:
        this.organizationParticipant.organizationId = this.organizationLevelCollection[1].orgId;
        this.organizationParticipant.organizationName = this.organizationLevelCollection[1].text;
        break;
      case this.organizationLevelCollection[2].value:
        this.organizationParticipant.organizationId = this.organizationLevelCollection[2].orgId;
        this.organizationParticipant.organizationName = this.organizationLevelCollection[2].text;
        this.organizationParticipant.includeChildren = true;
        this.organizationParticipant.tag = 'expression'
        break;
      // case this.organizationLevelCollection[3].value:
      //   this.organizationParticipant.organizationId = this.organizationLevelCollection[3].orgId;
      //   this.organizationParticipant.organizationName = '';
      //   this.organizationParticipant.includeChildren = true;
      //   this.organizationParticipant.tag = 'assign';
      //   break;
    }
  }
  getPerformers() {
    const users = this.usersCmp ? this.usersCmp.getPerformers() : [];
    const variable = this.varCmp ? this.varCmp.getPerformers() : null;
    const positions = this.posiCmp ? this.posiCmp.getPerformers() : [];
    const component = this.cmpCmp ? this.cmpCmp.getPerformers() : null;
    const reportingLine = this.reportingLineCmp ? this.reportingLineCmp.getPerformers() : null;
    const matrix = this.matrixCmp ? this.matrixCmp.getPerformers() : null;
    const activityExecutors = this.activityExecutorCmp ? this.activityExecutorCmp.getPerformers() : [];

    let userPerformers = []; // 用户参与者
    let activityExecutorPerformers = []; // 已办活动节点参与者

    if ((users && users.length > 0)) {
      userPerformers = userPerformers.concat(users);
    }
    if (activityExecutors && activityExecutors.length > 0) {
      activityExecutorPerformers = activityExecutorPerformers.concat(activityExecutors);
    }
    let organizationParticipant: OrganizationParticipantExpression;
    if (this.performerType === 'wf.OrganizationParticipantExpression') {
      if (this.organizationParticipant.organizationLevel === OrganizationLevel.VARORGANIZATION && this.organizationParticipant.tag === 'expression') {
      // if(this.organizationParticipant.organizationId === 'currentUnit') {
      //   this.organizationParticipant.organizationLevel = OrganizationLevel.UNIT;
      // }else if(this.organizationParticipant.organizationId === 'currentDepartment') {
      //   this.organizationParticipant.organizationLevel = OrganizationLevel.DEPARTMENT
      // }else if (this.organizationParticipant.organizationLevel === OrganizationLevel.VARORGANIZATION && this.organizationParticipant.tag === 'expression') {
      //   this.organizationParticipant.organizationLevel = OrganizationLevel.DEFAULT;
      // }else {
        this.organizationParticipant.organizationLevel = OrganizationLevel.DEFAULT;
      }
      organizationParticipant = this.organizationParticipant;
    }
    return { userPerformers, variable, positions, component, reportingLine, matrix, activityExecutorPerformers, organizationParticipant };
  }

  editConditon() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.organizationParticipant.condition);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.organizationParticipant.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  editOrganizationId() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Advanced);
    this.expr.addExpressionText(this.organizationParticipant.organizationId);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.organizationParticipant.organizationId = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  // selectionChange() {
  //   this.farrisOrgHelp.showFarrisDialog();
  //   this.farrisOrgHelp.multiSelect = false;
  //   const sub = this.farrisOrgHelp.selectionsChange.subscribe((res: { selections: any[] }) => {
  //     if (res.selections == null || res.selections.length == 0) {
  //       sub.unsubscribe();
  //       return;
  //     }
  //     sub.unsubscribe();
  //     const org = res.selections[0];
  //     this.organizationParticipant.organizationName = org.name;
  //     this.organizationParticipant.organizationId = org.orgId;
  //   });
  // }
}
